<div x-data="messageContent" class="chat-widget-message-content">
<div id="chat-widget-messages" class="chat-widget-messages" x-ref="scrollContainer">

    <template x-if="showBotGreeting">
        <div class="chat-widget-message">
            <div class="chat-widget-message-type-bot-answer">
                <div class="bot-greeting" x-raw="botGreeting"></div>
            </div>
        </div>
    </template>
    <template x-if="showBotSuggestions">
        <div id="chat-widget-bot-suggestions">
            <div class="chat-widget-message">
                <div class="chat-widget-message-type-bot-question">
                    <span>Vorschläge:</span>
                </div>
            </div>
            <template x-for="(suggestion, index) in chatSuggestions" :key="suggestion">
                <div class="chat-widget-message chat-widget-message-bot-suggestion">
                    <div @click="sendSuggestion" :data-suggestion="suggestion" class="chat-widget-message-type-bot-suggestion">
                        <span x-text="suggestion"></span>
                    </div>
                </div>
            </template>
        </div>
    </template>

    <template x-if="botHistoryMessages.length > 0">
        <template x-for="message in botHistoryMessages" :key="message.id">
            <div>
                <div class="chat-widget-message">
                    <div :class="message.cssClass" :data-attr-id="message.id">
                        <span class="message" x-raw="getBotHistoryMessageText(message)"></span>
                    </div>
                </div>
                <div :id="'chat-widget-feedback-inner-content_' + message.id"></div>
            </div>
        </template>
    </template>

    <template x-if="messages.length > 0">
        <template x-for="message in messages" :key="message.id">
            <div>
                <div class="chat-widget-message">
                    <div :class="message.cssClass" :data-attr-id="message.id">
                        <template x-if="message.type !== 'question'">
                            <span class="author" x-text="message.author"></span>
                        </template>
                        <span class="message" x-raw="getMessageText(message)"></span>
                        <template x-if="getMessageTime(message)">
                            <span class="time" x-text="getMessageTime(message)"></span>
                        </template>
                        <template x-if="getSendingStatus(message)">
                            <span class="sending-status" x-raw="getSendingStatus(message)" :title="getSendingStatusTooltip(message)"></span>
                        </template>
                    </div>
                </div>
                <div :id="'chat-widget-feedback-inner-content_' + message.id"></div>
            </div>
        </template>
    </template>

    <div id="chat-widget-content" class="chat-widget-content is-chat-view"></div>
        <div id="disclaimer" class="chat-widget-messages-disclaimer hide">
        <p>Angaben ohne Gewähr</p>
    </div>

    <div class="spinner-wrapper chat-widget-message-type-system" x-cloak x-show="spinnerVisibility">
        <div class="chat-widget-spinner">
            <div class="spinner-image"></div>
            <div class="spinner-message"><span x-raw="systemMessage"></span></div>
        </div>
    </div>

    <div class="system-error-message" x-show="showSystemErrorMessage">
        <span x-raw="systemErrorMessage"></span>
        <button @click="retryConnect"
                title="Neu verbinden"
                x-show="showReconnectButton"
                id="retry-connect-button"
                class="chat-widget-link close-chat-button">
            jetzt neu verbinden
        </button>
    </div>

    <div class="typing-wrapper" x-cloak x-show="agentTypingVisibility">
        <div class="typing">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
</div>

<div id="chat-widget-bottom-bar" class="chat-widget-bottom-bar">

    <div id="chat-widget-current-message" class="chat-widget-message-send">

        <textarea id="chat-widget-message-input"
                  data-speech-to-text="false"
                  x-ref="chatMessageInput"
                  x-model="currentMessage"
                  :placeholder="placeholder"
                  @keyup = "typeMessage"
                  @keyup.enter="sendMessage"
                  @input="updateCharCount"
                  class="chat-widget-message-send-input input input-text"
                  autocomplete="off"
                  aria-autocomplete="list"
                  aria-haspopup="true"
                  :maxlength="maxChatTextLength"
        ></textarea>

        <button @click="sendMessage"
                x-ref="sendButton"
                title="Nachricht Absenden"
                id="sendMessageButton"
                class="chat-widget-button-send button-send">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.53 14.04" width="25" height="25" class="svg">
                <polygon points="1.4 14.04 0 12.61 5.68 7.02 0 1.42 1.4 0 8.53 7.03 1.4 14.04"></polygon>
            </svg>
        </button>

        <div class="chat-widget-media-recorder-container" id="media-recorder-container" x-data="speechMessage()">
            <div class="chat-widget-media-recorder-container-controls">
                <div id="recording-status" x-ref="recordStatus" class="recording-status-text mt-3"></div>


                <!-- Aufnahme löschen -->
                <button  class="chat-widget-svg-button button-remove-record" @click="handleRemoveSpeech" x-ref="removeButton" x-show="showRemoveSpeechButton" x-cloak type="button" id="remove-speech-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 357 357">
                        <path d="M357 35.7 321.3 0 178.5 142.8 35.7 0 0 35.7l142.8 142.8L0 321.3 35.7 357l142.8-142.8L321.3 357l35.7-35.7-142.8-142.8z"/>
                    </svg>
                </button>

                <!-- Aufnahme Abbrechen -->
                <button class="chat-widget-svg-button button-cancel-record hide" @click="handleCancelClick" x-ref="cancelButton" type="button" id="cancel-recording-btn" hidden disabled>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 357 357">
                        <path d="M357 35.7 321.3 0 178.5 142.8 35.7 0 0 35.7l142.8 142.8L0 321.3 35.7 357l142.8-142.8L321.3 357l35.7-35.7-142.8-142.8z"/>
                    </svg>
                </button>

                <!-- Aufnahme Starten -->
                <button class="chat-widget-svg-button chat-widget-button-record" @click="handleStartButtonClick" x-ref="startButton" type="button" id="start-recording-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="25" height="25" viewBox="0 0 256 256" id="recording-active-icon" x-show="!isMicrophonePermissionDenied">
                        <g style="stroke:none;stroke-width:0;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:none;fill-rule:nonzero;opacity:1">
                            <path d="M45 70.968c-16.013 0-29.042-13.028-29.042-29.042a3.099 3.099 0 0 1 6.198 0C22.157 54.522 32.404 64.77 45 64.77c12.595 0 22.843-10.248 22.843-22.843a3.098 3.098 0 1 1 6.198 0C74.042 57.94 61.013 70.968 45 70.968" style="stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:#000;fill-rule:nonzero;opacity:1" transform="translate(1.407 1.407)scale(2.81)"/>
                            <path d="M45 60.738c-10.285 0-18.7-8.415-18.7-18.7V18.7C26.3 8.415 34.715 0 45 0s18.7 8.415 18.7 18.7v23.337c0 10.285-8.415 18.701-18.7 18.701M45 89.213a3.1 3.1 0 0 1-3.099-3.099V68.655a3.099 3.099 0 0 1 6.198 0v17.459A3.1 3.1 0 0 1 45 89.213" style="stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:#000;fill-rule:nonzero;opacity:1" transform="translate(1.407 1.407)scale(2.81)"/>
                            <path d="M55.451 90H34.549a3.098 3.098 0 1 1 0-6.198H55.45A3.098 3.098 0 1 1 55.451 90" style="stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:#000;fill-rule:nonzero;opacity:1" transform="translate(1.407 1.407)scale(2.81)"/>
                        </g>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Ebene 1" width="25" height="25"  viewBox="0 0 25 25" id="recording-denied-icon" x-show="isMicrophonePermissionDenied">
                        <path d="M12.49 19.61c-4.4 0-7.96-3.57-7.97-7.97a.85.85 0 1 1 1.7 0c0 3.46 2.81 6.26 6.27 6.27 3.46 0 6.26-2.81 6.27-6.27a.85.85 0 1 1 1.7 0c0 4.4-3.57 7.97-7.97 7.97"/>
                        <path d="M12.49 16.8c-2.83 0-5.12-2.3-5.13-5.13v-6.4C7.35 2.45 9.66.14 12.49.14s5.13 2.31 5.13 5.13v6.4c0 2.82-2.31 5.13-5.13 5.13m0 7.82a.85.85 0 0 1-.85-.85v-4.79a.85.85 0 1 1 1.7 0v4.79c0 .47-.38.85-.85.85"/>
                        <path d="M15.35 24.83H9.61a.85.85 0 1 1 0-1.7h5.74a.85.85 0 1 1 0 1.7"/>
                        <rect width="1.77" height="30.57" x="11.18" y="-2.7" rx=".89" ry=".89" style="stroke:#fff;stroke-miterlimit:10;stroke-width:.5px" transform="rotate(-39.2 12.073 12.589)"/>
                    </svg>
                </button>

                <!-- Aufnahme Beenden -->
                <button class="chat-widget-button-send button-stop-record hide" @click="handleStopClick" x-ref="stopButton" type="button" id="stop-recording-btn" hidden disabled>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 26 26">
                        <path d="M.3 14c-.2-.2-.3-.5-.3-.7s.1-.5.3-.7l1.4-1.4c.4-.4 1-.4 1.4 0l.1.1 5.5 5.9c.2.2.5.2.7 0L22.8 3.3h.1c.4-.4 1-.4 1.4 0l1.4 1.4c.4.4.4 1 0 1.4l-16 16.6c-.2.2-.4.3-.7.3a1 1 0 0 1-.7-.3L.5 14.3z"/>
                    </svg>
                </button>
            </div>

            <div class="input-length-warning"
                 x-show="chatMessageCharCount > 0"
                 :class="{ 'is-limit-reached': chatMessageCharCount >= maxChatTextLength }"
                 x-cloak>
                    <span x-show="chatMessageCharCount < maxChatTextLength"
                          x-text="chatMessageCharCount.toLocaleString('de-DE') + '/' + maxChatTextLength.toLocaleString('de-DE') + ' Zeichen'"></span>
                    <span x-show="chatMessageCharCount >= maxChatTextLength"
                          x-text="'Max. Zeichen erreicht. ' + maxChatTextLength + '/' + maxChatTextLength + ' Zeichen.'"></span>
            </div>

            <!-- Bestätigungsdialog -->
            <div x-show="showStartConfirm"
                 @keydown.escape.window="handleCancelConfirm"
                 x-cloak
                 class="chat-widget-overlay"
            >
                <div @click="handleCancelConfirm"
                     class="chat-widget-overlay-backdrop"
                ></div>
                <!-- Dialog -->
                <div role="dialog"
                     aria-modal="true"
                     aria-labelledby="confirm-dialog-title"
                     class="chat-widget-overlay-dialog"
                >
                    <div class="chat-widget-overlay-header">
                        <h2>Hinweis</h2>
                        <button @click="handleCancelConfirm" class="chat-widget-link chat-widget-overlay-header-close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 357 357">
                                <path d="M357 35.7 321.3 0 178.5 142.8 35.7 0 0 35.7l142.8 142.8L0 321.3 35.7 357l142.8-142.8L321.3 357l35.7-35.7-142.8-142.8z"/>
                            </svg>
                        </button>
                    </div>

                    <h4>Nachricht verwerfen?</h4>
                    <template x-if="isSalutationSie()"><p>Ihre Nachricht wird gelöscht und nicht gesendet. Möchten Sie fortfahren?</p></template>
                    <template x-if="!isSalutationSie()"><p>Deine Nachricht wird gelöscht und nicht gesendet. Möchtest du fortfahren?</p></template>
                    <div class="chat-widget-overlay-button-bar">
                        <button @click="handleConfirmStart"
                                type="button"
                                class="chat-widget-button"
                        >Ja, fortfahren</button>
                        <button @click="handleCancelConfirm"
                                type="button"
                                class="chat-widget-button tertiary"
                        >Nein, behalten</button>
                    </div>
                </div>
            </div>

            <!-- Mikrofon-Berechtigungsdialog -->
            <div x-show="showMicPermissionDialog"
                 class="chat-widget-overlay"
            >
                <div class="chat-widget-overlay-backdrop"></div>
                <div role="dialog"
                     aria-modal="true"
                     aria-labelledby="mic-permission-dialog-title"
                     class="chat-widget-overlay-dialog"
                >
                    <div class="chat-widget-overlay-header">
                        <h2>Hinweis</h2>
                        <button @click="showMicPermissionDialog = false" class="chat-widget-link chat-widget-overlay-header-close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 357 357">
                                <path d="M357 35.7 321.3 0 178.5 142.8 35.7 0 0 35.7l142.8 142.8L0 321.3 35.7 357l142.8-142.8L321.3 357l35.7-35.7-142.8-142.8z"/>
                            </svg>
                        </button>
                    </div>
                    <h4 id="mic-permission-dialog-title">Mikrofonzugriff deaktiviert</h4>
                    <template x-if="isSalutationSie()"><p>Damit Sie die Sprachfunktion nutzen können, erlauben Sie bitte den Zugriff auf Ihr Mikrofon in den <b>Browser-Einstellungen</b>.</p></template>
                    <template x-if="!isSalutationSie()"><p>Damit Du die Sprachfunktion nutzen kannst, erlaube bitte den Zugriff auf Dein Mikrofon in den <b>Browser-Einstellungen</b>.</p></template>
                    <div class="chat-widget-overlay-button-bar">
                        <button @click="handleRetryMicPermission"
                                type="button"
                                class="chat-widget-button"
                        >Verstanden</button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>

<div id="chat-widget-buttons" class="chat-widget-link-bar">

    <button @click="closeChat"
            title="Beenden"
            id="close-chat-button"
            class="chat-widget-link close-chat-button">
        Chat beenden
    </button>

    <button @click="switchToAgentChat"
            x-show="switchToAgentChatButtonVisibility"
            title="Persönlicher Chat"
            id="agentChatButton"
            class="chat-widget-link agent-button hide">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16"  viewBox="0 0 48 48" class="chat-widget-live-chat">
            <path fill="#000" stroke="#000" stroke-width=".8" d="M24 2.5c10.3 0 18.7 8.4 18.7 18.7a1.3 1.3 0 1 1-2.7 0 16 16 0 0 0-32 0 1.3 1.3 0 1 1-2.7 0C5.3 10.9 13.7 2.5 24 2.5Z"/>
            <path fill="#000" stroke="#000" stroke-width=".8" d="M9.4 19.8q1.3.1 1.4 1.4v11.1q-.1 1.3-1.4 1.4H5.6a4 4 0 0 1-4-4v-6a4 4 0 0 1 4-3.9zm-3.8 2.7q-1.2.1-1.3 1.3v6q.1 1 1.3 1.2H8v-8.5zM42.4 19.8a4 4 0 0 1 4 4v6a4 4 0 0 1-4 3.9h-3.8q-1.3-.1-1.4-1.4V21.2q.1-1.3 1.4-1.4zM40 31h2.5q1.2-.1 1.3-1.3v-6q-.1-1-1.3-1.2H40z"/>
            <path fill="#000" stroke="#000" stroke-width=".8" d="M41.4 31q1.2.1 1.3 1.3c0 6.2-5 11.3-11.2 11.3H31a1.3 1.3 0 1 1 0-2.7h.4c4.7 0 8.5-3.9 8.5-8.6q.1-1.2 1.4-1.3Z"/>
            <path fill="#000" stroke="#000" stroke-width=".8" d="M29.2 39a3.3 3.3 0 0 1 0 6.5h-4a3.3 3.3 0 0 1 0-6.6zm-4 2.6q-.5 0-.6.6t.6.7h4q.5 0 .6-.7 0-.5-.6-.6z"/>
            <path fill="#000" d="M24 40h7v4h-7z"/>

        </svg>
        <span>Live Chat</span>
    </button>

    <button @click="closeConnection"
            id="close-connection-button"
            class="hide">
    </button>

</div>

    <template x-if="showBotGreeting">
        <div class="chat-widget-terms-of-use">
            <span class="chat-widget-terms-of-use-text">Hinweise zur Nutzung des KI-Assistenten</span>
            <div x-data="{ openModal: false }" class="chat-widget-terms-of-use-text">

                <button
                    @click="openModal = true"
                    class="chat-widget-link chat-widget-terms-of-use-text"
                >Mehr erfahren</button>

                <div x-show="openModal" class="chat-widget-overlay modal-overlay">
                    <div class="chat-widget-overlay-backdrop" @click.away="openModal = false">
                        <div class="chat-widget-overlay-dialog">
                            <div class="chat-widget-overlay-header">
                                <h2>Hinweis</h2>
                                <button @click="openModal = false" class="chat-widget-link chat-widget-overlay-header-close">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 357 357">
                                        <path d="M357 35.7 321.3 0 178.5 142.8 35.7 0 0 35.7l142.8 142.8L0 321.3 35.7 357l142.8-142.8L321.3 357l35.7-35.7-142.8-142.8z"/>
                                    </svg>
                                </button>
                            </div>
                            <p>
                                Der <span x-text="trademarkName"></span> KI-Assistent beantwortet KI-gestützt
                                Fragen zu Produkten, Tarifen, Services
                                und individuellen Anliegen.
                                <br><br>
                                Der <span x-text="trademarkName"></span> KI-Assistent unterstützt
                                <template x-if="isSalutationSie()"><span>Sie</span></template>
                                <template x-if="!isSalutationSie()"><span>Dich</span></template>
                                bestmöglich als Chatbot. Bitte
                                <template x-if="isSalutationSie()"><span>überprüfen Sie</span></template>
                                <template x-if="!isSalutationSie()"><span>überprüfe</span></template>
                                wichtige Informationen
                                sicherheitshalber noch einmal.
                                <br><br>
                                Weitere Informationen
                                <template x-if="isSalutationSie()"><span>finden Sie</span></template>
                                <template x-if="!isSalutationSie()"><span>findest Du</span></template>
                                in unseren <a :href="markenUrl + '/datenschutz'" x-data="{markenUrl: trademarkWebsite}" target="_blank">Datenschutzhinweisen</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

</div>